<template>
  <div>
    <div class="row">
      <div class="col-6 offset-md-3 text-center mt-3"></div>
      <div class="col-3 text-right mt-3">
        <button
          class="btn btn-sm btn-info mr-1"
          @click.prevent
          @click="abrirModalSms()"
        >
          <i class="fa fa-sms"></i>
        </button>
        <button
          class="btn btn-sm btn-info"
          @click.prevent
          @click="abrirModalEmail()"
        >
          <i class="fa fa-envelope"></i>
        </button>
      </div>
    </div>

    <modal
      class="modal fade"
      v-model="modalSms.open"
      ref="modal-sms"
      :title="'Enviar mensaje de texto'"
      id="modal-sms"
      @hide="cerrarModalSms()"
    >
      <template v-if="telefonos.length > 0">
        <form class="form-horizontal">
          <div class="form-group">
            <label class="col-md-3 control-label" for="text-input"
              >Destinatario*</label
            >
            <div class="col-md-9">
              <select
                name=""
                v-model="mensaje.destinatario"
                class="form-control"
              >
                <option value="">Seleccione una opcion</option>
                <option
                  v-for="(telefono, index) in telefonos"
                  :key="index"
                  :value="telefono.valor"
                >
                  {{ telefono.valor }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label class="col-md-3 control-label" for="text-input"
              >Mensaje*</label
            >
            <div class="col-md-9">
              <textarea
                v-model.trim="mensaje.mensaje"
                class="form-control"
                placeholder="Digite el mensaje de texto"
              ></textarea>
            </div>
          </div>
        </form>
        <span slot="footer">
          <btn type="button" class="btn btn-danger" @click="cerrarModalSms()"
            >Cerrar</btn
          >&nbsp;
          <btn
            type="button"
            :disabled="
              (mensaje.destinatario.length > 0 && mensaje.mensaje.length > 0) ||
              this.loading
                ? null
                : 'disabled'
            "
            class="btn btn-info"
            @click="enviarSms()"
            v-text="'Enviar'"
          ></btn>
        </span>
      </template>
      <template v-else>
        <div class="text-center">
          <h3>
            No tiene números telefonicos registrados para reliazar esta
            operación.
          </h3>
        </div>
      </template>
    </modal>

    <modal
      class="modal fade"
      v-model="modalEmail.open"
      ref="modal-email"
      :title="'Enviar correo electronico'"
      id="modal-email"
      @hide="cerrarModalEmail()"
    >
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <template v-if="emails.length > 0">
        <form class="form-horizontal">
          <!-- input correo -->
          <div class="form-group">
            <label class="col-md-3 control-label" for="text-input"
              >Destinatario*</label
            >
            <div class="col-md-9">
              <select name="" v-model="email.destinatario" class="form-control">
                <option value="">Seleccione una opcion</option>
                <option
                  v-for="(email, index) in emails"
                  :key="index"
                  :value="email.valor"
                >
                  {{ email.valor }}
                </option>
              </select>
            </div>
          </div>
          <!-- input asunto -->
          <div class="form-group">
            <label class="col-md-3 control-label" for="text-input"
              >Asunto*</label
            >
            <div class="col-md-9">
              <input
                type="text"
                v-model.trim="email.asunto"
                class="form-control"
                placeholder="Digite su el asunto del email"
              />
            </div>
          </div>
          <!-- input ask si es adjunto -->
          <div class="form-group">
            <label class="col-md-3 control-label" for="text-input"
              >Desea añadir un archivo adjunto?
            </label>
            <div class="col-md-9">
              <select name="" v-model="adjunto" class="form-control">
                <option value="NO">No</option>
                <option value="SI">Si</option>
              </select>
            </div>
          </div>

          <template v-if="adjunto == 'SI'">
            <!-- input de la obligacion -->
            <div class="form-group">
              <label class="col-md-3 control-label" for="text-input"
                >Seleccione una obligación *</label
              >
              <!-- <div class="col-md-9">
                <select
                  name=""
                  v-model="obligacion_seleccionada"
                  class="form-control"
                  :disabled="allObligaciones"
                >
                  <option value="">Seleccione una opcion</option>
                  <option
                    v-for="(oligacion, index) in obligaciones"
                    :key="index"
                    :value="oligacion"
                  >
                    {{ oligacion.codigo }}
                  </option>
                </select>
              </div> -->
              <v-select
                class="col-md-9"
                multiple
                size="md"
                placeholder="Seleccione ..."
                v-model="obligacion_seleccionada"
                :options="obligaciones"
                :reduce="(options) => options"
                label="identificador_obligacion"
                :loading="loading"
                append-to-body
                :tabindex="0"
                :disabled="allObligaciones"
              >
                <template #no-options> No hay registro </template>

                <template #spinner="{ loading }">
                  <div
                    v-if="loading"
                    style="border-left-color: rgba(88, 151, 251, 0.71)"
                    class="spinner-border spinner-border-sm"
                  ></div>
                </template>
              </v-select>
            </div>

            <!-- input selecionar todas las obligaciones -->
            <!-- <div class="form-group">
              <div class="form-check form-check-inline ml-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inlineCheckbox1"
                  v-model="allObligaciones"
                  :value="true"
                />
                <label class="form-check-label" for="inlineCheckbox1"
                  >todas las obigaciones</label
                >
              </div>
            </div> -->
            <!-- input tipo de documento -->
            <div
              v-if="obligacion_seleccionada.length > 0 || allObligaciones"
              class="form-group"
            >
              <label class="col-md-6 control-label" for="text-input"
                >Seleccione el tipo de documento</label
              >
              <br />
              <div class="col-md-9">
                <div v-for="(documento, index) in documentos" :key="index">
                  <label>
                    <input
                      type="checkbox"
                      v-model="tipo_documento"
                      :value="documento.value"
                      :disabled="validateDocumento(documento)"
                    />
                    &nbsp;
                    {{ documento.nombre }}</label
                  >
                </div>
              </div>
            </div>
          </template>
          <!-- input mensaje -->
          <div class="form-group">
            <label class="col-md-3 control-label" for="text-input"
              >Mensaje*</label
            >
            <div class="col-md-9">
              <textarea
                v-model.trim="email.mensaje"
                class="form-control"
                placeholder="Digite su email"
              ></textarea>
            </div>
          </div>
        </form>
        <span slot="footer">
          <btn type="button" class="btn btn-danger" @click="cerrarModalEmail()"
            >Cerrar</btn
          >&nbsp;
          <btn
            type="button"
            :disabled="
              email.destinatario.length > 0 &&
              email.mensaje.length > 0 &&
              email.asunto.length > 0
                ? null
                : 'disabled'
            "
            class="btn btn-info"
            @click="enviarEmail()"
            >Enviar</btn
          >
        </span>
      </template>
      <template v-else>
        <div class="text-center">
          <h3>No tiene correos electronicos para realizar esta operación.</h3>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import documentos from "@/data/tipo_documento.json";

export default {
  name: "Notificador",
  data: () => {
    return {
      allObligaciones: false,
      modalSms: {
        open: false,
        titulo: "",
        contenido: "",
      },
      modalEmail: {
        open: false,
        titulo: "",
        contenido: "",
      },
      mensaje: {
        destinatario: "",
        mensaje: "",
      },
      email: {
        destinatario: "",
        asunto: "",
        adjunto: [],
        obligacion: "",
        mensaje: "",
      },
      adjunto: "NO",
      tipo_documento: [],
      loading: false,
      obligacion_seleccionada: [],
    };
  },
  computed: {
    documentos() {
      return this.allObligaciones || this.obligacion_seleccionada.length > 1
        ? documentos.filter((element) => element.multiples)
        : documentos;
    },
    telefonos() {
      return this.$store.getters["gestion/infoContacto"]["telefono"]
        ? this.$store.getters["gestion/infoContacto"]["telefono"]
        : [];
    },
    emails() {
      return this.$store.getters["gestion/infoContacto"]["email"]
        ? this.$store.getters["gestion/infoContacto"]["email"]
        : [];
    },
    obligaciones() {
      return this.$store.getters["deudor/obligaciones"]
        ? this.$store.getters["deudor/obligaciones"]
        : [];
    },
  },
  components: {},
  methods: {
    abrirModalSms() {
      this.modalSms.open = true;
    },
    cerrarModalSms() {
      this.modalSms.open = false;
      this.mensaje.mensaje = "";
      this.mensaje.destinatario = "";
    },
    validateDocumento(value) {
      if (
        value.value == "paz-salvo" &&
        this.obligacion_seleccionada.filter((element) => element.saldo_real > 0)
          .length > 0
      ) {
        return true;
      } else {
        return value.disabled;
      }
    },
    enviarSms() {
      this.$store
        .dispatch("gestion/enviarSMS", {
          numero_contacto: this.mensaje.destinatario,
          mensaje: this.mensaje.mensaje,
          accion: "mensaje-personlizado",
        })
        .then(() => {
          this.$notify({
            title: "Enviado!",
            type: "success",
            content: "Mensaje de texto enviado con exito.",
          });
          this.cerrarModalSms();
        })
        .catch(() => {
          this.$notify({
            title: "Error!",
            type: "warning",
            content:
              "Se presento un error a la hora de enviar el mensaje de texto",
            duration: 0,
          });
        });
    },
    abrirModalEmail() {
      this.modalEmail.open = true;
    },
    cerrarModalEmail() {
      this.modalEmail.open = false;
      this.email.mensaje = "";
      this.email.asunto = "";
      this.email.adjunto = [];
      this.email.destinatario = "";
      this.adjunto = "NO";
    },
    obtenerAdjunto() {
      this.loading = true;
      this.$store
        .dispatch("gestion/generarDocumento", {
          datos: this.obligacion_seleccionada,
          tipo: this.tipo_documento,
          accion: "guardar",
        })
        .then((data) => {
          this.email.adjunto = data.data;
          this.loading = false;
          /* this.$notify({
                    title: 'Archivo descargado',
                    content:'El archivo fue descargado satisfactoriamente.',
                    type: 'success'
                }); */
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({
            title: "Fallo al descargar",
            content:
              "Se produjo un error al tratar de descargar el archivo, por favor inténtelo mas tarde." +
              error,
            type: "danger",
          });
        });
    },
    enviarEmail() {
      this.loading = true;
      this.$store
        .dispatch("gestion/generarDocumento", {
          datos: this.allObligaciones
            ? [this.obligaciones[0]]
            : this.obligacion_seleccionada,
          tipo: this.tipo_documento,
          all_obligaciones: this.allObligaciones,
          accion: "guardar",
        })
        .then((data) => {
          this.email.adjunto = data.data;
          this.$store
            .dispatch("gestion/enviarEmail", {
              destinatario: this.email.destinatario,
              contenido: this.email.mensaje,
              asunto: this.email.asunto,
              adjunto: this.email.adjunto,
            })
            .then(() => {
              this.loading = false;
              this.$notify({
                title: "Enviado!",
                type: "success",
                content: "Email enviado con exito.",
              });
              this.cerrarModalEmail();
            })
            .catch(() => {
              this.loading = false;
              this.$notify({
                title: "Error!",
                type: "warning",
                content: "Se presento un error a la hora de enviar el email",
                duration: 0,
              });
              this.cerrarModalEmail();
            });
        })
        .catch((error) => {
          this.loading = false;

          this.$notify({
            title: "Fallo al descargar",
            content:
              "Se produjo un error al tratar de descargar el archivo, por favor inténtelo mas tarde." +
              error.response.data
                ? error.response.data
                : error,
            type: "danger",
          });
          this.modalEmail.open = false;
        });
    },
  },
  watch: {
    adjunto: function (newVal) {
      if (newVal == "NO") {
        this.obligacion_seleccionada = [];
        this.tipo_documento = [];
        this.email.adjunto = [];
      }
    },
    obligacion_seleccionada: function () {
      this.tipo_documento = [];
      this.email.adjunto = [];
    },
    allObligaciones: function (newVal) {
      if (newVal) {
        this.tipo_documento = [];
        this.obligacion_seleccionada = [];
      }
    },
    /*tipo_documento: function (newVal) {
      if (newVal != "") {
        this.obtenerAdjunto();
      }
      if (newVal != oldVal) {
                this.busqueda.tipo_adicion = '';
                this.busqueda.pagare = null;
                this.adicion = {};
                this.$store.commit('pagos/setPagos', {replace: true, datos: []});
                this.vaciarValores();
            }
    },*/
  },
  mounted() {
    //
  },
};
</script>
<style>
.fade:not(.show)#modal-email {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.fade:not(.show)#modal-sms {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: block;
}

.modal-title {
  font-weight: bold;
}

.vs__dropdown-menu {
  z-index: 1050 !important;
}
</style>
